var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#instagram_svg__clip0_913_32864)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "instagram_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.009.68H0v30h30.009v-30z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#instagram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 4.604c-3.008 0-3.386.013-4.567.067a8.125 8.125 0 00-2.689.515 5.667 5.667 0 00-3.24 3.24 8.092 8.092 0 00-.516 2.689c-.052 1.181-.066 1.56-.066 4.567 0 3.008.014 3.385.067 4.566.02.92.193 1.828.515 2.69a5.668 5.668 0 003.24 3.24c.86.323 1.769.497 2.688.515 1.181.054 1.559.068 4.567.068 3.01 0 3.385-.014 4.567-.067a8.14 8.14 0 002.69-.515 5.677 5.677 0 003.24-3.242c.32-.86.495-1.77.515-2.689.052-1.18.067-1.558.067-4.566 0-3.007-.014-3.386-.067-4.567a8.211 8.211 0 00-.515-2.689 5.668 5.668 0 00-3.24-3.24 8.156 8.156 0 00-2.692-.515c-1.18-.054-1.557-.067-4.567-.067H15zm-1 2h1c2.958 0 3.31.01 4.477.063a6.133 6.133 0 012.056.382 3.671 3.671 0 012.103 2.102c.244.659.373 1.354.38 2.056.053 1.168.066 1.519.066 4.475 0 2.957-.011 3.308-.065 4.475a6.126 6.126 0 01-.381 2.056 3.675 3.675 0 01-2.103 2.102 6.112 6.112 0 01-2.056.381c-1.168.052-1.519.065-4.476.065-2.958 0-3.31-.011-4.477-.065a6.145 6.145 0 01-2.057-.383 3.669 3.669 0 01-2.103-2.1 6.125 6.125 0 01-.38-2.057c-.053-1.168-.065-1.519-.065-4.476 0-2.958.01-3.308.064-4.475a6.134 6.134 0 01.381-2.056 3.671 3.671 0 012.103-2.103 6.125 6.125 0 012.057-.382c1.023-.047 1.418-.06 3.483-.063L14 6.604zm6.908 1.84a1.329 1.329 0 100 2.658 1.329 1.329 0 000-2.658zm-5.914 1.553a5.688 5.688 0 10-.003 11.376 5.688 5.688 0 00.003-11.376zm0 2a3.692 3.692 0 11-3.692 3.693A3.69 3.69 0 0115 11.989l-.007.008z",
    fill: "#D9D9D9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "instagram_svg__clip0_913_32864"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .68)",
    d: "M0 0h30v30H0z"
  })))));
}
export default __webpack_public_path__ + "assets/static/media/instagram.5b6b5317.svg";
export { SvgInstagram as ReactComponent };